module.exports = __webpack_public_path__ + "static/img/fav.6e85469.png";